import React from 'react';
import { Routes, Route } from 'react-router-dom';
import Main from './components/Main';
import About from './components/About';
import Contact from './components/Contact';
import Projects from './components/Projects';

function Router() {
  return (
    <Routes>
      <Route
        path="/"
        element={<Main />}
      />
      <Route
        path="*"
        element={(
          <main style={{ padding: '1rem' }}>
            <p>404</p>
          </main>
      )}
      />
      <Route
        path="/about"
        element={<About self />}
      />
      <Route
        path="/contact"
        element={<Contact self />}
      />
      <Route
        path="/projects"
        element={<Projects self />}
      />
      {/* <Route
        path="/map"
        element={<Map />}
      /> */}
    </Routes>
  );
}

export default Router;
